import { SITE } from "./site";

export type WhatsAppLead = {
  name: string;
  phone: string;
  service: string;
  address?: string;
  urgency?: string;
  message?: string;
};

export function buildWhatsAppMessage(lead: WhatsAppLead): string {
  const lines = [
    "Hola Vega Reparaciones, necesito un servicio técnico.",
    "",
    `• Nombre: ${lead.name}`,
    `• Teléfono: ${lead.phone}`,
    `• Servicio: ${lead.service}`,
  ];
  if (lead.address) lines.push(`• Dirección / zona: ${lead.address}`);
  if (lead.urgency) lines.push(`• Urgencia: ${lead.urgency}`);
  if (lead.message) {
    lines.push("", "Mensaje:", lead.message);
  }
  return lines.join("\n");
}

export function buildWhatsAppUrl(lead: WhatsAppLead): string {
  const text = encodeURIComponent(buildWhatsAppMessage(lead));
  return `https://wa.me/${SITE.whatsappNumber}?text=${text}`;
}

export function quickWhatsAppUrl(prefilled: string): string {
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(prefilled)}`;
}
